import * as Sentry from "@sentry/browser";

const useSentry = !window.location.hostname.match(/localhost/);

if (useSentry) {
  Sentry.init({
    dsn: "https://4b5244772d28422e8683999c91353668@o401912.ingest.sentry.io/5748186",
    release: "1.0.0",
  });
}

export default Sentry;

export function reportIssue(): void {
  const eventId = Sentry.captureMessage("user error reported");
  Sentry.showReportDialog({
    labelSubmit: "Submit",
    title: "Report an issue with the dialer",
    eventId,
  });
}
